module.exports = __webpack_public_path__ + "img/marine_insurance.4c758e91.png";